import { useTranslation } from 'react-i18next';
import KpiCard from './KpiCard';
import { useDashboardKpis } from './useDashboardKpis';
import { useKpiPeriod } from './useKpiPeriod';
import PeriodToggle from './PeriodToggle';

function ListIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="6" width="18" height="14" rx="2" />
      <path d="M3 10h18M9 6V3M15 6V3" />
    </svg>
  );
}

export default function RentalsMtdWidget() {
  const { t } = useTranslation();
  const { data, loading } = useDashboardKpis();
  const [period, setPeriod] = useKpiPeriod('rentals');

  const isTotal = period === 'total';
  const value = data == null ? 0 : isTotal ? data.rentals_total : data.rentals_30d;
  const mtd = data?.rentals_mtd ?? 0;

  const periodLabel = isTotal
    ? t('dashboard.kpi_period_total', { defaultValue: 'i alt' })
    : t('dashboard.kpi_period_30d', { defaultValue: 'sidste 30 dage' });

  return (
    <KpiCard
      label={
        <span className="inline-flex items-center gap-2">
          <span>{t('dashboard.kpi_rentals', { defaultValue: 'Udlejninger' })}</span>
          <PeriodToggle value={period} onChange={setPeriod} />
        </span>
      }
      value={value}
      icon={<ListIcon />}
      iconTone="ink"
      delta={data ? { label: periodLabel, direction: 'neutral' } : undefined}
      caption={data ? t('dashboard.kpi_rentals_mtd_subtitle', {
        count: mtd,
        defaultValue: `${mtd} denne måned`,
      }) : undefined}
      loading={loading}
    />
  );
}
